<div class="fault-detail-component" [class.prevent-focus]="faultDetailsService.preventTempFormFocusForIos">
  <div class="fault-detail-step-content">
    <div class="fault-detail-form-container" *ngIf="faultItem?.data">
      <div [class.hidden]="!faultItem?.data?.ModifiedOn" class="fault-detail-tooltip-button">
        {{'MM.fault.lastChange' | translate }} {{faultItem.data.ModifiedOn | mydocmaDate:'medium'}}
        <div style="display:inline" #tooltip>
          <button style="font: small-caption;" (click)=" isFaultInfoOpen = !isFaultInfoOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin" mat-icon-button>
            <mydocma-custom-mat-icon  style="font-size: 12px; color: grey" [iconName]="'_info'"></mydocma-custom-mat-icon>
          </button>
        </div>


        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isFaultInfoOpen"
        >
          <div class="example-list">
            <p  *ngIf="faultItem?.data && faultItem.data.Creator && faultItem.data.CreatedOn">
              {{'MM.fault.createdBy' | translate }} {{faultItem.data.Creator?.LastName }} {{faultItem.data.Creator?.FirstName }} {{'MM.fault.onDate' | translate }} {{faultItem.data.CreatedOn | mydocmaDate}} {{'MM.fault.atDate' | translate }} {{faultItem.data.CreatedOn | mydocmaDate:'mediumTime'}}
            </p>
            <p *ngIf="faultItem?.data && faultItem.data.Modifier && faultItem.data.ModifiedOn">
              {{'MM.fault.modifiedBy' | translate }} {{faultItem.data.Modifier?.LastName }} {{faultItem.data.Modifier?.FirstName }}  {{'MM.fault.onDate' | translate }} {{faultItem.data.ModifiedOn | mydocmaDate}} {{'MM.fault.atDate' | translate }} {{faultItem.data.ModifiedOn | mydocmaDate:'mediumTime'}}
            </p>
            <p *ngIf="faultItem?.data && faultItem.data.CreatedOnMobile">
              {{'MM.fault.mobileBy' | translate }} {{'MM.fault.onDate' | translate }} {{ faultItem.data.CreatedOnMobile  | mydocmaDate}} {{'MM.fault.atDate' | translate }} {{ faultItem.data.CreatedOnMobile | mydocmaDate:'mediumTime' }}
            </p>
            <p *ngIf="faultItem?.data && faultItem.data.ModifiedOnMobile">
              {{'MM.fault.mobileModified' | translate }} {{'MM.fault.onDate' | translate }} {{ faultItem.data.ModifiedOnMobile | mydocmaDate}} {{'MM.fault.atDate' | translate }} {{ faultItem.data.ModifiedOnMobile | mydocmaDate:'mediumTime'}}
            </p>
          </div>

        </ng-template>
      </div>

      <mydocma-dynamic-form
        class="mydocma-form-faults"
        [class.hidden]="(faultDetailsService.onFaultLoading | async) && faultItem.isNew"
        [formConfig]="faultDetailsService.formConfig$ | async"
                            (ready)="formReady($event)">
      </mydocma-dynamic-form>

      <div style="text-align: center; margin-top: 10px">
        <button class="settings-button"  (click)="onOpenFieldConfiguration()" [disabled]="(changeService.changesPerMask.get(faultRightPane) | async)" *ngIf="!(isNew$ | async) || !(changeService.changesPerMask.get(faultRightPane) | async)"
          mat-stroked-button type="button" style="margin: 0 0 10px 0">
          <mat-icon>settings</mat-icon>
          {{'MM.general.button.field-settings' | translate }}
        </button>
      </div>


    </div>
  </div>
</div>
